import React, { FC } from 'react';
import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import { ListingsApi } from 'app/api/listings';
import { Controller, useForm } from 'react-hook-form';
import Modal from 'components/shared/Modal';
import { Button, Field, Select } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: AnyFunction;
  initialTimezone?: string;
  onSubmit(form: FormState): void;
};

type FormState = { timezone: string };

const EditProfileTimezoneForm: FC<Props> = (props) => {
  const timezones = useQuery(queryKey.timezones(), ListingsApi.timezones);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormState>({
    defaultValues: {
      timezone: props.initialTimezone ?? undefined,
    },
  });
  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <Modal.Content>
        <Field.Group>
          <Field.Label required className="tw-text-sm">
            {t('timeZone')}
          </Field.Label>
          <Field.Error>{errors.timezone?.message}</Field.Error>
          <Controller
            name="timezone"
            control={control}
            rules={{ required: t('isRequired') }}
            render={({ field: { value, onChange } }) => (
              <Select
                value={{
                  value,
                  label: value
                    ? timezones.data?.record?.[value] ?? value
                    : t('selectTimezone'),
                }}
                onChange={(option) => onChange(option?.value)}
                options={timezones.data?.iterable ?? []}
              />
            )}
          />
        </Field.Group>
      </Modal.Content>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onClose}>
          {t('cancel')}
        </Button>
        <Button type="submit">{t('save')}</Button>
      </Modal.Footer>
    </form>
  );
};

export default EditProfileTimezoneForm;
